import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/drugManagement/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/drugManagement/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/drugManagement/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/drugManagement/submit',
    method: 'post',
    data: row
  })
}

export const moduleExcel = () => {
  return request({
    url: '/health/drugManagement/excel/download',
    method: 'get',
    responseType: 'blob'
  })
}
